export const rippleOnSurface = 'rgba(51, 82, 103, 0.12)';
export const rippleOnLink = 'rgba(24, 100, 171, 0.15)';
export const rippleOnPrimary = 'rgba(255, 255, 255, 0.3)';
// Same white ripple, named for surfaces that are dark rather than primary.
export const rippleOnDark = rippleOnPrimary;
export const rippleOnOutline = 'rgba(112, 72, 232, 0.2)';
